import React from "react";
import {
    Dialog,
    useMediaQuery,
    useTheme,
    Typography,
    Box,
    Button,
} from "@mui/material";
import { IoCloseCircleOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { openBulkActionDialog, getAllStudents } from "../../Redux/Dashboard/DashboardSlice";
import Spinner from "../../Spinner/Spinner";
import { Notify } from "../../CommonPopup/Popup";
import { bulkAction } from "../../Redux/Auth/AuthSlice";

const BulkActionDialog = () => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    const dispatch = useDispatch();

    const loader = useSelector((s) => s.DashboardSlice.bulkActionLoader);
    const open = useSelector((s) => s.DashboardSlice.showBulkActionDialog);
    const selectedBulkStudents = useSelector((s) => s.DashboardSlice.selectedBulkStudents);
    const selectedBulkAction = useSelector((s) => s.DashboardSlice.selectedBulkAction);
    console.log("selected bulk students===>", selectedBulkStudents);

    const handleClose = () => {
        dispatch(openBulkActionDialog(false));
    };

    const handleSubmit = () => {
        const userIds = selectedBulkStudents
            .map((u) => u._id || u.id)
            .filter(Boolean);

        if (!userIds.length) {
            Notify({
                data: "error",
                msg: "No valid users selected",
                type: "error",
            });
            return;
        }

        const payload = {
            action: selectedBulkAction,
            userIds,
        };

        dispatch(bulkAction(payload))
            .unwrap()
            .then((data) => {
                Notify({
                    data: data.success ? "success" : "error",
                    msg: data?.message,
                });

                if (data.success) {
                    dispatch(getAllStudents());
                    dispatch(openBulkActionDialog(false));
                }
            })
            .catch((err) => {
                Notify({
                    data: "error",
                    msg: err?.message || "Failed to perform action",
                });
            });
    };
    const actionLabels = {
        paid: "Mark as Paid",
        unpaid: "Mark as Unpaid",
        block: "Block Users",
        unblock: "Unblock Users",
        reset: "Reset Device",
        delete: "Delete Users",
    };

    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    p: 3,
                    bgcolor: "#fafafa",
                },
            }}
        >
            <Box>
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="h5" fontWeight="bold">
                        Confirm Action
                    </Typography>
                    <IoCloseCircleOutline
                        size={28}
                        onClick={handleClose}
                        style={{ cursor: "pointer", color: "#f44336" }}
                    />
                </Box>

                {/* Action Info */}
                <Typography mb={1} fontWeight="600">
                    Action:
                </Typography>
                <Typography mb={2} color="primary">
                    {actionLabels[selectedBulkAction] || selectedBulkAction}
                </Typography>

                {/* Selected Users */}
                <Typography mb={1} fontWeight="600">
                    Selected Users ({selectedBulkStudents?.length || 0}):
                </Typography>

                <Box
                    sx={{
                        maxHeight: "150px",
                        overflowY: "auto",
                        background: "#f1f5f9",
                        borderRadius: "8px",
                        p: 2,
                    }}
                >
                    {selectedBulkStudents?.map((user) => (
                        <Typography key={user?.id} fontSize={14}>
                            • {user?.name}
                        </Typography>
                    ))}
                </Box>

                {/* Warning */}
                {(selectedBulkAction === "delete") && (
                    <Typography mt={2} color="error" fontSize={14}>
                        ⚠️ This action may be irreversible. Please confirm before proceeding.
                    </Typography>
                )}

                {/* Buttons */}
                <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
                    <Button variant="outlined" onClick={handleClose}>
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        color={selectedBulkAction === "delete" ? "error" : "primary"}
                        onClick={handleSubmit}
                        disabled={loader}
                    >
                        {loader ? <Spinner /> : "Confirm"}
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
};

export default BulkActionDialog;